module.exports = __webpack_public_path__ + "static/media/blog-img1.443497e7.jpg";